[
  "backgrounds/alaska_state_capitol.jpg",
  "backgrounds/berries.jpg",
  "backgrounds/castner_ice_cavern.jpg",
  "backgrounds/fireweed.jpg",
  "backgrounds/juneau.jpg",
  "backgrounds/ketchikan.jpg",
  "backgrounds/portage_rd.jpg"
]
